module.exports = __webpack_public_path__ + "fonts/rzzy.1583afec.TTF";